// @flow
import React from "react";
import I18n from "../../i18n/I18n";
import styles from "./ReportsEmpty.scss";

const ReportsEmpty = (props: Object) => {
  let { largeText } = props;
  let medText = null;

  switch (props.reportsType) {
    case 2:
      largeText = I18n.getText(
        "reports.empty-summary-weekly",
        {},
        "You dont have any weekly reports"
      );
      medText = "";
      break;

    case 1:
      largeText = I18n.getText(
        "reports.empty-heading",
        {},
        "Select Date range above to Generate Reports"
      );
      medText = I18n.getText(
        "reports.empty-summary",
        {},
        "You can have separated reports for many categories and download "
      );
      break;

    case 3:
      largeText = I18n.getText(
        "reports.empty-summary-monthly",
        {},
        "You dont have any monthly reports"
      );
      medText = "";
      break;

    default:
      largeText =
        props.largeText ||
        I18n.getText(
          "reports.empty-heading",
          {},
          "Select Date range above to Generate Reports"
        );
      medText =
        props.medText ||
        I18n.getText(
          "reports.empty-summary",
          {},
          "You can have separated reports for many categories and download "
        );
      break;
  }
  return (
    <div className={styles.maBoxWrapper}>
      <div className={styles.emptyResultsCtr} />
      <div className={styles.content}>
        <div className={styles.dataRow}>
          <div>
            <span className={styles.largeText}>{largeText}</span>
          </div>
          {medText && <p className={styles.medText}>{medText}</p>}
        </div>
      </div>
    </div>
  );
};

export default ReportsEmpty;



// WEBPACK FOOTER //
// ./src/components/reports/ReportsEmpty.js